import ExtraCostsForm from "./ExtraCostsForm";
import React, {useState} from "react";
import ExtraCostsList from "./ExtraCostsList";
import './assets/css/extraCosts.scss'
import ExtraCostsState from "./interface/ExtraCostsState";

export default function ExtraCosts() {
    const [state, setState] = useState<ExtraCostsState>({
        error: false,
        extraCostsName: "",
        extraCostsPercentage: "",
        extraCostsPrice: "",
        extraCostsPriceSeparator: "",
        type: "percentage",
        state: "active",
        message: "",
    })

    return (
        <section className={"other-container print-container extra-cost-container"}>
            <ExtraCostsForm state={state} setState={setState}/>
            <ExtraCostsList state={state} setState={setState}/>
        </section>
    );
}